import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Lazyload from 'react-lazyload';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit * 2,
        margin: 30
      },
    root: {
        maxWidth: '60%',
        maxHeight: 250,
        width: 'initial',
        height: 'initial'
    }
})

function Audience(props) {
    const { classes } = props.props;
    return(
        <div className="audience advertise-layout">
            <h2 style={{ padding: '30px 0px 10px', color: '#ed7123', fontSize: 30 }}>Our reach and audience</h2>
            <Grid container direction="row">
                <Grid item md={6} xs={12}>
                    <Paper className={classes.paper}>
                    <div className="people">
                <div className="img-para">
                        <img src="/static/advertiseWithUs/icon/team.svg" />
                    <h5>Millenials</h5>
                </div>
                
                    <div className="single-chart pull-right">
                        <SvgIcon viewBox="0 0 36 36" classes={{ root: classes.root }} className='green'>
                        <path className="circle-bg"
                            d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path className="circle wow"
                            strokeDasharray="50, 100"
                            d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <text x="18" y="20.35" className="percentage">50%</text>
                        </SvgIcon>
                    </div>

                </div>
                </Paper>
                <Paper className={classes.paper}>
                <div className="urban">
                <div className="img-para">
                        <img src="/static/advertiseWithUs/icon/building.svg" />
                    <h5>Urban</h5>
                </div>
                
                    <div className="single-chart pull-right">
                        <SvgIcon viewBox="0 0 36 36" classes={{ root: classes.root }} className='blue'>
                        <path className="circle-bg"
                            d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path className="circle wow"
                            strokeDasharray="90, 100"
                            d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <text x="18" y="20.35" className="percentage">90%</text>
                        </SvgIcon>
                    </div>

                </div>
                    </Paper>
                </Grid>
                <Grid item md={6} xs={12}>
                <div className="con rate">
                    <div className='male-container'>
                        <img className='img-responsive male-img' src="/static/advertiseWithUs/icon/man-user.svg" />
                        <div className="male">male 60%</div>
                    </div> 
                    <div className='female-container'>
                    <img className='img-responsive female-img' src="/static/advertiseWithUs/icon/woman.svg" />
                    <div className="female">female 40%</div>
                    </div>
                </div>
                </Grid>
            </Grid>     
        </div>
    )
}
class OurAudience extends React.Component{
    constructor(props){
        super(props);
        this.state = {
           ssrDone: false,
        };   
      } 
    render(){
        const { classes } = this.props;
        return(
            this.state.ssrDone && isMobile ?
            <Audience props={this.props} />
            :
            <Lazyload
                height={800}
            >
                <Audience props={this.props} />
            </Lazyload> 
        )
    }
    componentDidMount(){
        this.setState({
            ssrDone: true,
        });
    }
}
export default withStyles(styles)(OurAudience);